import { ChangeEvent, ReactNode, useId, useRef } from 'react';

import { Flex, HStack, Stack, Switch, Text } from '@bonusly/design-system';

type ToggleSetItemProps = {
	label: string;
	description?: string;
	isChecked: boolean;
	isDisabled?: boolean;
	testId?: string;
	onChange: (e: ChangeEvent<HTMLInputElement>) => void;
	// Optional control rendered to the left of the toggle (e.g. a "Manage"
	// button for connectors that have a dedicated settings surface).
	action?: ReactNode;
};

export const ToggleSetItem = ({ label, description, isChecked, isDisabled, testId, onChange, action }: ToggleSetItemProps) => {
	const id = useId();
	const switchRef = useRef<HTMLInputElement>(null);

	return (
		<Flex align="center" justify="space-between" gap={4} data-testid={testId}>
			<Stack spacing={0} onClick={() => !isDisabled && switchRef.current?.click()}>
				<Text id={id} fontSize="sm" fontWeight="medium">
					{label}
				</Text>
				{description && (
					<Text fontSize="sm" color="text.softest">
						{description}
					</Text>
				)}
			</Stack>
			<HStack spacing={3} flexShrink={0}>
				{action}
				<Switch ref={switchRef} aria-labelledby={id} isChecked={isChecked} isDisabled={isDisabled} onChange={onChange} flexShrink={0} />
			</HStack>
		</Flex>
	);
};
